import React from 'react'
import AuthenticationSection from './ManageParts/AuthenticationSection'
import Influencer from './ManageParts/Influencer'

export default function Manage() {

  return (
    <div className="grid grid-cols-2 gap-4 bg-rb-grey dark:bg-rb-dark-mode-background p-4">
      <Influencer />
      <AuthenticationSection />
    </div>
  )
}